import Swiper, { EffectFade, Pagination, Autoplay } from 'swiper';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class PartnersCarousel {
	static init(e) {
		const partnerCarousel = e.detail.element.querySelector('[data-m-partners-carousel]');
		if (partnerCarousel) {
			new PartnersCarousel(partnerCarousel);
		}
	}

	constructor(partnerCarousel) {
		const sliderElement = partnerCarousel.querySelector('[data-swiper]');
		if (!sliderElement) {
			return;
		}

		this.dynamicUnderline = partnerCarousel.querySelector('[data-dynamic-underline]');

		this.buttons = partnerCarousel.querySelectorAll('[data-button]');

		const options = {
			modules: [EffectFade, Pagination, Autoplay],
			effect: 'fade',
			fadeEffect: {
				crossFade: false,
			},
			slidesPerView: 1,
			allowTouchMove: false,
			keyboard: true,
			speed: 0,
			loop: false,
			centeredSlides: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'fraction',
				renderFraction: function (currentClass, totalClass) {
					return (
						'<span class="' +
						currentClass +
						'"></span>' +
						' <span>&nbsp;|&nbsp;</span> ' +
						'<span class="' +
						totalClass +
						'"></span>'
					);
				},
			},
			on: {
				init: (swiper) => {
					const slide = swiper.slides[swiper.activeIndex];
					const slideRect = slide.getBoundingClientRect();
					const underlineRect = slide.querySelector('.partner-label').getBoundingClientRect();
					gsap.to(this.dynamicUnderline, {
						top: underlineRect.top - slideRect.top,
						scaleX: underlineRect.width / 100,
						duration: 0.5,
						ease: 'power.inOut2',
					});

					swiper.autoplay.stop();

					ScrollTrigger.create({
						trigger: sliderElement,
						start: 'top center',
						end: 'bottom center',
						onToggle: (self) => {
							if (self.isActive) {
								swiper.autoplay.start();
							} else {
								swiper.autoplay.stop();
							}
						},
					});

					this.activateButton(swiper.activeIndex);
				},
				slideChange: (swiper) => {
					// Change underline width
					const slide = swiper.slides[swiper.activeIndex];
					const slideRect = slide.getBoundingClientRect();
					const underlineRect = slide.querySelector('.partner-label').getBoundingClientRect();
					gsap.to(this.dynamicUnderline, {
						top: underlineRect.top - slideRect.top,
						scaleX: underlineRect.width / 100,
						duration: 0.5,
						ease: 'power.inOut2',
					});

					this.activateButton(swiper.activeIndex);
				},
			},
		};

		this.swiper = new Swiper(sliderElement, options);
	}

	activateButton(index) {
		if (!this.buttons) {
			return;
		}

		this.buttons.forEach((button, i) => {
			if (index == i) {
				button.classList.add('active');
			} else {
				button.classList.remove('active');
			}
		});
	}
}
